import { defineMessages } from 'react-intl';

export default defineMessages({
  close: {
    id: 'view.messagesFilters.close',
    defaultMessage: 'Close',
  },
  showItems: {
    id: 'view.datatable.items',
    defaultMessage: 'Show {pageSize} items',
  },
  multiSortTips: {
    id: 'view.datatable.multiSortTips',
    defaultMessage:
      'Hold the SHIFT key while you click headers to control sorting by multiple columns.',
  },
});
